import * as M from "@discovery/prelude/lib/data/maybe";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _IsUserPremiumFromPartners } from "@discovery/common-dplus/lib/state";
import * as styles from "./styles.css";
import { Icon, Icons } from "../../atoms/icon";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import { PremiumButton } from "../premium-button";
import phoneNumberFormatter from "../../../utils/phoNumberFormatter";
import { navigateTo } from "../../../utils/common";
import Strings from "../../../utils/hardcoded.json";
import { useUser } from "../../../utils/hooks";
import { setAuthRedirectUrl } from "../../../utils/authUrl";
export const UserAccount = ({ webAuthRedirectionUrl, closeDrawer, profilePicUrl, userM, }) => {
    const { isAnonymous, isPremiumUser } = useUser();
    const [isPremiumUserFromPartner] = useGlobalState(_IsUserPremiumFromPartners);
    const userDetailsM = M.map((user) => ({
        firstNameM: user.attributes.firstName,
        lastNameM: user.attributes.lastName,
        userNameM: user.attributes.username,
        userPhoneNumberM: user.attributes.validatedPhoneNumber,
    }), userM);
    const firstNameM = M.fromMaybe(M.map((user) => user.firstNameM, userDetailsM), M.of(""));
    const firstName = M.fromMaybe(firstNameM, "");
    const lastNameM = M.fromMaybe(M.map((user) => user.lastNameM, userDetailsM), M.of(""));
    const userNameM = M.fromMaybe(M.map((user) => user.userNameM, userDetailsM), M.of(""));
    const userPhoneNumberM = M.fromMaybe(M.map((user) => user.userPhoneNumberM, userDetailsM), M.of(""));
    const isUserPremium = isPremiumUser || isPremiumUserFromPartner;
    const loginForUrl = webAuthRedirectionUrl + "/" + "login";
    const profileForUrl = webAuthRedirectionUrl + "/" + "my-account";
    const getLogin = () => {
        const authRedirect = setAuthRedirectUrl(window.location.pathname);
        navigateTo(`${loginForUrl}?returnUrl=${authRedirect}`);
    };
    const getProfile = () => {
        const authRedirect = setAuthRedirectUrl(window.location.pathname);
        isAnonymous
            ? navigateTo(`${loginForUrl}?returnUrl=${profileForUrl}`)
            : navigateTo(`${profileForUrl}?returnUrl=${authRedirect}`);
    };
    return (React.createElement("div", { className: styles.userAccountContainer },
        React.createElement("div", { id: "#profileIcon", onClick: getProfile, className: styles.profileIconWrapper }, profilePicUrl ? (React.createElement("img", { src: profilePicUrl, className: styles.profilePicSocialMedia })) : (React.createElement(Icon, { type: Icons.ProfileIcon, className: styles.profilePic }))),
        React.createElement(React.Fragment, null, isAnonymous ? (React.createElement(Typography, { classNameM: M.of(styles.profileName), variant: HeaderVariants.headingSix, tag: Tags.h6 },
            React.createElement(React.Fragment, null, Strings.GUEST_USER))) : firstNameM && lastNameM ? (React.createElement("div", { className: styles.userName },
            React.createElement(RenderMaybe, null, M.map((firstName) => {
                return (React.createElement(Typography, { classNameM: M.of(styles.profileName), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, firstName)));
            }, firstNameM)),
            React.createElement(RenderMaybe, null, M.map((lastName) => {
                return (React.createElement(Typography, { classNameM: M.of(styles.profileName), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, lastName)));
            }, lastNameM)))) : (userNameM && (React.createElement(RenderMaybe, null, M.map((userName) => {
            return (React.createElement(Typography, { classNameM: M.of(styles.profileName), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                React.createElement(React.Fragment, null, userName)));
        }, userNameM))))),
        !firstName && (React.createElement(RenderMaybe, null, M.map((number) => {
            return (number && (React.createElement(React.Fragment, null,
                React.createElement(Typography, { classNameM: M.of(styles.phoneNumber), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, phoneNumberFormatter(number))))));
        }, userPhoneNumberM))),
        isUserPremium ? (React.createElement(PremiumButton, { isPremiumAccount: true, closeDrawer: closeDrawer })) : (React.createElement(PremiumButton, { isPremiumAccount: false, closeDrawer: closeDrawer })),
        isAnonymous && (React.createElement("span", { onClick: getLogin, className: styles.loginOrSignupWrapper },
            React.createElement(Icon, { type: Icons.LogIn, className: styles.logoutBtn, color: "white" }),
            React.createElement("div", { id: "#signupLoginLink" },
                React.createElement(Typography, { classNameM: M.of(styles.loginOrSignup), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, Strings.SIGN_IN)))))));
};

